/* eslint-disable import/no-unresolved */
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { useBrandDetails } from 'dw-au-react-components';
import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';
import ArrowIcon from '../../../components/Icons/ArrowIcon';
import SocialShare from '../SocialShare';
import { useParams } from 'react-router-dom';

const StyledBodyContent = styled.section`
	.blogcontent-wrapper {
		max-width: 970px;
		margin: auto;
		margin-top: -80px;
		padding-bottom: 0px;
		padding-top: 25px;

		@media screen and (max-width: 767px) {
			padding: 25px;
		}

		&::before {
			content: '';
			position: absolute;
			width: 100%;
			height: 200px;
			background: #ffffff;
			left: 0;
			top: 0;
			box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.08);
			z-index: -1;
		}

		> p {
			margin-bottom: 20px;
			color: #545454;
			&:last-of-type {
				margin-bottom: 0;
			}
			> b {
				color: #212121;
			}
		}
	}

	.breadcrum-overflow {
		overflow: auto;
		margin-bottom: 20px;
	}

	.breadcrums {
		display: flex;
		border-bottom: 1px solid #a0a0a0;
		width: 100%;
		min-width: max-content;
		p {
			color: #a0a0a0;
			font-size: 16px;
			font-weight: 400;
			line-height: 24px;
			text-align: center;
			padding-right: 10px;
		}
		.active {
			&:hover {
				text-decoration: underline;
			}
		}
		@media screen and (max-width: 767px) {
			p {
				font-size: 14px;
			}
		}
	}

	.goback-btn {
		max-width: 970px;
		margin: auto;
		margin-bottom: 60px;

		a {
			display: inline-flex;
			align-items: center;
			flex-wrap: wrap;
			column-gap: 8px;

			svg {
				transition: transform 0.3s ease-in-out;
			}

			&:hover {
				svg {
					transform: translateX(-5px);
				}
			}
		}
	}
	.vir-body-content {
		h1 {
			font-size: 32px !important;
		}
		h2 {
			font-size: 28px !important;
		}
		h3 {
			font-size: 24px !important;
		}
	}
`;

const StyledProductCarousel = styled.div`
	.blog__product-carousel {
		padding-bottom: 50px;
		padding-top: 15px;
		.homepage__recommender {
			h4 {
				font-family: 'Noto Serif', 'Roboto', 'Helvetica Neue', Helvetica, Arial,
					sans-serif !important;
				text-transform: none;
				font-size: 24px;
				letter-spacing: 0.25px;
				line-height: 32px;
				.vir & {
					margin-bottom: 0px !important;
				}
				.wpe & {
					margin-bottom: 0px !important;
				}
			}
		}
	}
`;

const BodyContent = ({ bodyContent, bodyContentV2, title, categoryTitle }) => {
	const brandDetails = useBrandDetails();
	let { slug, category } = useParams();

	const CUSTOM = ({ children }) => {
		if (
			typeof children[0] !== 'object' &&
			children[0].indexOf('<iframe ') > -1
		) {
			let iframeLink = children[0].split('src="')[1].split('"')[0];
			if (iframeLink.indexOf('youtube') > -1) {
				iframeLink = iframeLink + '?modestbranding=1&rel=0';
			}
			return (
				<p className='iframeLink position-relative'>
					<iframe
						src={iframeLink}
						className='position-absolute h-100'
						width='100%'
						height='400'
						allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
						allowFullScreen
					/>
				</p>
			);
		} else {
			return <p>{children}</p>;
		}
	};

	const renderOption = {
		renderNode: {
			[BLOCKS.EMBEDDED_ASSET]: (node) => {
				return (
					<p>
						<img
							className='mw-100'
							src={node.data.target.fields.file.url}
							alt={node.data.target.fields.file.title}
							title={node.data.target.fields.file.title}
						/>
					</p>
				);
			}
		},
		[BLOCKS.PARAGRAPH]: (node, children) => <CUSTOM>{children}</CUSTOM>,
		[INLINES.HYPERLINK]: (node, children) => {
			return (
				<a target='_blank' rel='noopener noreferrer' href={node.data.uri}>
					{children}
				</a>
			);
		}
	};

	return (
		<>
			{bodyContent && (
				<StyledBodyContent>
					<div className='container'>
						<div
							className={`blogcontent-wrapper background-white p-80 position-relative ${
								brandDetails.tag === 'vir' ? 'vir-body-content' : ''
							}`}
						>
							<div className='breadcrum-overflow'>
								<div className='breadcrums'>
									<Link to='/blog'>
										<p className='active'>Blog Home</p>
									</Link>
									<p>/</p>
									<Link to={`/blog/${category?.replaceAll('-', ' ')}`}>
										<p className='active'>{categoryTitle}</p>
									</Link>
									<p>/</p>
									<p>{title}</p>
								</div>
							</div>

							{documentToReactComponents(bodyContent, renderOption)}
							{bodyContentV2 ? (
								<div
									dangerouslySetInnerHTML={{
										__html: bodyContentV2
									}}
								></div>
							) : null}
						</div>

						<StyledProductCarousel>
							<div
								id='product_carousel'
								data-key='apac_product_carousel'
								className='blog__product-carousel'
								data-sectionName='Blog'
								data-slug={slug}
							></div>
							<div id='product_carousel_container'></div>
						</StyledProductCarousel>

						<SocialShare />
						<div className='goback-btn text-center'>
							<Link
								to={`/blog/${category?.replaceAll('-', ' ')}`}
								className='btn btn-outline-secondary'
							>
								<ArrowIcon position='left' />
								Go Back
							</Link>
						</div>
					</div>
				</StyledBodyContent>
			)}
		</>
	);
};

export default BodyContent;
